import React from "react";
import BrokerAdminNavigation from "./BrokerAdminNavigation";
import { Link } from "react-router-dom";

const QuoteyAdminNavigation = (props) => {
  const superadmin = [
    "brokerage",
    "paymentdetails",
    "userdata",
    "apistatus",
    "branding",
    "insurervisibility",
    "user",
    "bms",
    "details",
    "aboutus",
    "insurercontacts",
    "whatsNew",
    "quoteyDashboard",
  ];
  const showBrokerSuperAdminCollapsedView = superadmin.includes(props.active);
  const insureradmin = [
    "insurer",
    "logoandcolor",
    "insurerappetite",
    "insurerdata",
    "customBind",
    "brokeragelist",
  ];
  const showInsurerAdminCollapsedView = insureradmin.includes(props.active);
  const ipfsdetailadmin = [
    "paymentprovider",
    "ipfsDetail",
    "insurer-details",
    "mga-details",
  ];
  const showPaymentDetailsCollapsedView = ipfsdetailadmin.includes(
    props.active
  );
  // const showBrokerSuperAdminCollapsedView = superadmin.includes(props.active);
  // const insureradmin = ["insurer", "insurerdefaults", "logoandcolor"]
  // const showInsurerAdminCollapsedView = insureradmin.includes(props.active);
  const menustyles = {
    className: "list-group-item list-group-item-action",
    activeClassName:
      "list-group-item list-group-item-light list-group-item-action active",
  };

  const quoteyadminlinks = [
    {
      className: showBrokerSuperAdminCollapsedView
        ? menustyles.activeClassName
        : menustyles.className,
      to: "/quoteyadmin/brokerage",
      name: "Brokerage Super Admin",
      subtitle: "Manage brokerages and users",
    },
    {
      className: showInsurerAdminCollapsedView
        ? menustyles.activeClassName
        : menustyles.className,
      to: "/quoteyadmin/insurer",
      name: "Insurer Management",
      subtitle: "Manage insurers",
    },
    {
      className:
        props.active === "rating"
          ? menustyles.activeClassName
          : menustyles.className,
      to: "/quoteyadmin/rating",
      name: "Rating Management",
      subtitle: "Manage rating",
    },
    {
      className:
        props.active === "question"
          ? menustyles.activeClassName
          : menustyles.className,
      to: "/quoteyadmin/question",
      name: "Question Admin",
      subtitle: "Manage questions and flow",
    },
    {
      className:
        props.active === "data"
          ? menustyles.activeClassName
          : menustyles.className,
      to: "/quoteyadmin/data",
      name: "Data",
      subtitle: "Extract Data",
    },
    // {
    //   className:
    //     props.active === "reports"
    //       ? menustyles.activeClassName
    //       : menustyles.className,
    //   to: "/quoteyadmin/reports",
    //   name: "Reports",
    //   subtitle: "Download Reports",
    // },
    {
      className:
        props.active === "category"
          ? menustyles.activeClassName
          : menustyles.className,
      to: "/quoteyadmin/category",
      name: "Category",
      subtitle: "Category Management",
    },
    {
      className: showPaymentDetailsCollapsedView
        ? menustyles.activeClassName
        : menustyles.className,
      to: "/quoteyadmin/paymentprovider",
      name: "Payment Provider Details",
      // subtitle: "Add Payment Provider ",
    },
  ];

  const submenustyles = {
    className:
      "list-group-item list-group-flush  list-group-item-dark  list-group-item-action",
    activeClassName:
      "list-group-item list-group-flush list-group-item-info list-group-item-action active",
  };

  const brokeradminlinks = [
    {
      className:
        props.active === "details"
          ? submenustyles.activeClassName
          : submenustyles.className,
      to: props.brokerage
        ? "/quoteyadmin/details?c=" + encodeURIComponent(props.brokerage)
        : "/quoteyadmin/details",
      name: "Brokerage Details",
    },
    {
      className:
        props.active === "user"
          ? submenustyles.activeClassName
          : submenustyles.className,
      to: props.brokerage
        ? "/quoteyadmin/user?c=" + encodeURIComponent(props.brokerage)
        : "/quoteyadmin/user",
      name: "User Management",
    },
    {
      className:
        props.active === "insurervisibility"
          ? submenustyles.activeClassName
          : submenustyles.className,
      to: props.brokerage
        ? "/quoteyadmin/insurervisibility?c=" +
          encodeURIComponent(props.brokerage)
        : "/quoteyadmin/insurervisibility",
      name: "Insurer Visibility",
    },
    {
      className:
        props.active === "insurercontacts"
          ? submenustyles.activeClassName
          : submenustyles.className,
      to: props.brokerage
        ? "/quoteyadmin/insurercontacts?c=" +
          encodeURIComponent(props.brokerage)
        : "/quoteyadmin/insurercontacts",
      name: "Insurer Contacts",
    },
    {
      className:
        props.active === "branding"
          ? submenustyles.activeClassName
          : submenustyles.className,
      to: props.brokerage
        ? "/quoteyadmin/branding?c=" + encodeURIComponent(props.brokerage)
        : "/quoteyadmin/branding",
      name: "Logo and Colors",
    },
    {
      className:
        props.active === "bms"
          ? submenustyles.activeClassName
          : submenustyles.className,
      to: props.brokerage
        ? "/quoteyadmin/bms?c=" + encodeURIComponent(props.brokerage)
        : "/quoteyadmin/bms",
      name: "Broker Management System (BMS)",
    },
    {
      className:
        props.active === "aboutus"
          ? submenustyles.activeClassName
          : submenustyles.className,
      to: props.brokerage
        ? "/quoteyadmin/aboutus?c=" + encodeURIComponent(props.brokerage)
        : "/quoteyadmin/aboutus",
      name: "About Us",
    },
    {
      className:
        props.active === "operationList"
          ? submenustyles.activeClassName
          : submenustyles.className,
      to: "/quoteyadmin/operationList?c=" + encodeURIComponent(props.brokerage),
      name: "Operation List",
    },
    {
      className:
        props.active === "whatsNew"
          ? submenustyles.activeClassName
          : submenustyles.className,
      to: "/quoteyadmin/whatsNew",
      name: "Whats New?",
    },
    {
      className:
        props.active === "quoteyDashboard"
          ? submenustyles.activeClassName
          : submenustyles.className,
      to: "/quoteyadmin/quoteyDashboard",
      name: "Quotey Dashboard",
    },
    // {
    //     className: props.active === "apistatus" ? submenustyles.activeClassName : submenustyles.className,
    //     to: '/quoteyadmin/apistatus',
    //     name: 'Customize APIs',
    // },
    // {
    //     className: props.active === "userdata" ? submenustyles.activeClassName : submenustyles.className,
    //     to: '/quoteyadmin/userdata',
    //     name: 'Your Data',
    // },
    // {
    //     className: props.active === "paymentdetails" ? submenustyles.activeClassName : submenustyles.className,
    //     to: '/quoteyadmin/paymentdetails',
    //     name: 'Manage Payment',
    // },
  ];

  const insureradminlinks = [
    {
      className:
        props.active === "logoandcolor"
          ? submenustyles.activeClassName
          : submenustyles.className,
      to: "/quoteyadmin/logoandcolor?c=" + encodeURIComponent(props.brokerage),
      name: "Insurer Logo",
    },
    {
      className:
        props.active === "insurerappetite"
          ? submenustyles.activeClassName
          : submenustyles.className,
      to:
        "/quoteyadmin/insurerappetite?c=" + encodeURIComponent(props.brokerage),
      name: "Insurer Appetite",
    },
    {
      className:
        props.active === "brokeragelist"
          ? submenustyles.activeClassName
          : submenustyles.className,
      to: "/quoteyadmin/brokeragelist?c=" + encodeURIComponent(props.brokerage),
      name: "Brokerage List",
    },
    {
      className:
        props.active === "insurerdata"
          ? submenustyles.activeClassName
          : submenustyles.className,
      to: "/quoteyadmin/insurerdata?c=" + encodeURIComponent(props.brokerage),
      name: "Insurer Data",
    },
    {
      className:
        props.active === "customBind"
          ? submenustyles.activeClassName
          : submenustyles.className,
      to: "/quoteyadmin/customBind",
      name: "Custom Bind PDF Dashboard",
    },
  ];
  const supersubmenustyles = {
    className:
      "list-group-item list-group-flush  list-group-item-light  list-group-item-action",
    activeClassName:
      "list-group-item list-group-flush list-group-item-primary list-group-item-action active",
  };

  const paymentProvideradminlinks = [
    {
      className:
        props.active === "paymentprovider" ||
        "ipfsDetail" ||
        "insurer-details" ||
        "mga-details"
          ? supersubmenustyles.activeClassName
          : supersubmenustyles.className,
      to: "/quoteyadmin/paymentprovider",
      name: "IPFS",
      subitems: [
        {
          className:
            props.active === "paymentprovider"
              ? submenustyles.activeClassName
              : submenustyles.className,
          to: "/quoteyadmin/paymentprovider",
          name: "Add Payment Provider",
        },
        {
          className:
            props.active === "ipfsDetail"
              ? submenustyles.activeClassName
              : submenustyles.className,
          to: "/quoteyadmin/ipfsDetail",
          name: "Brokerage IPFS Details",
        },
        {
          className:
            props.active === "insurer-details"
              ? submenustyles.activeClassName
              : submenustyles.className,
          to: "/quoteyadmin/insurer-details",
          name: "Add Insurer Code",
        },
      ],
    },
  ];

  return (
    <div>
      <ul className="list-group" style={{ listStyle: "none" }}>
        {quoteyadminlinks.map((link) => (
          <li key={link.name} style={{ fontFamily: "GibsonSemiBd" }}>
            <div>
              <Link
                style={{ paddingLeft: "30px" }}
                className={link.className}
                role="button"
                to={link.to}
              >
                {link.name}
                <p
                  style={{
                    fontFamily: "GibsonItalic",
                    fontSize: "10px",
                    margin: "0",
                  }}
                >
                  {link.subtitle}
                </p>
              </Link>
              {showBrokerSuperAdminCollapsedView &&
              link.name === "Brokerage Super Admin" ? (
                <div>
                  <ul className="list-group" style={{ listStyle: "none" }}>
                    {brokeradminlinks.map((link) => (
                      <li
                        key={link.name}
                        style={{ fontFamily: "GibsonRegular" }}
                      >
                        <Link
                          style={{
                            paddingLeft: "30px",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          }}
                          className={link.className}
                          role="button"
                          to={link.to}
                        >
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : showInsurerAdminCollapsedView &&
                link.name === "Insurer Management" ? (
                <div>
                  <ul className="list-group" style={{ listStyle: "none" }}>
                    {insureradminlinks.map((link) => (
                      <li
                        key={link.name}
                        style={{ fontFamily: "GibsonRegular" }}
                      >
                        <Link
                          style={{
                            paddingLeft: "30px",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          }}
                          className={link.className}
                          role="button"
                          // href={link.to}
                          to={link.to}
                        >
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : showPaymentDetailsCollapsedView &&
                link.name === "Payment Provider Details" ? (
                <div>
                  <ul className="list-group " style={{ listStyle: "none" }}>
                    {paymentProvideradminlinks.map((link) => (
                      <li
                        key={link.name}
                        style={{ fontFamily: "GibsonRegular" }}
                      >
                        <Link
                          style={{
                            paddingLeft: "60px",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          }}
                          className={link.className}
                          role="button"
                          to={link.to}
                        >
                          {link.name}
                        </Link>
                        {link.subitems && link.subitems.length > 0 && (
                          <ul
                            className="list-group"
                            style={{ listStyle: "none" }}
                          >
                            {link.subitems.map((subItem) => (
                              <li
                                key={subItem.name}
                                style={{ fontFamily: "GibsonRegular" }}
                              >
                                <Link
                                  style={{
                                    paddingLeft: "60px",
                                    paddingTop: "5px",
                                    paddingBottom: "5px",
                                  }}
                                  className={subItem.className}
                                  role="button"
                                  to={subItem.to}
                                >
                                  {subItem.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div></div>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuoteyAdminNavigation;
